// extracted by mini-css-extract-plugin
module.exports = {"CommentContents":"CommentContents_CommentContents__oA6RG"};